import { Icon, Text } from '@mntn/ui-components'
import { Button } from '@/components/shared'
import { config } from '@/config'

export function StoreButton() {
  return (
    <Button size="small" variant="active" className="gap-2 rounded-xs h-auto px-6 py-4" asChild>
      <a href={config.VITE_SELECT_URL} target="_blank" rel="noopener noreferrer">
        <Text variant="base-sb" className="text-header-inverse">
          Go to Store
        </Text>
        <Icon name="ExternalLink" className="text-header-inverse size-5" />
      </a>
    </Button>
  )
}
